import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Users, Megaphone, LogOut, Zap, CreditCard } from 'lucide-react';

const navItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/campaigns', icon: Megaphone, label: 'Campaigns' },
  { to: '/leads', icon: Users, label: 'Leads' },
  { to: '/pricing', icon: CreditCard, label: 'Pricing' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'var(--bg)' }}>
      <aside style={{
        width:220, flexShrink:0,
        background:'var(--bg2)',
        borderRight:'1px solid var(--border)',
        display:'flex', flexDirection:'column',
        position:'sticky', top:0, height:'100vh',
        padding:'20px 12px'
      }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:28, padding:'0 8px' }}>
          <div style={{
            width:32, height:32, borderRadius:9,
            background:'linear-gradient(135deg,#6c47ff,#3b8bff)',
            display:'flex', alignItems:'center', justifyContent:'center',
            boxShadow:'0 0 16px rgba(108,71,255,.35)'
          }}>
            <Zap size={16} color="white" fill="white" />
          </div>
          <span style={{ fontWeight:800, fontSize:16, letterSpacing:'-.02em', color:'var(--text)' }}>
            ColdCraft<span style={{ color:'var(--accent)' }}> AI</span>
          </span>
        </div>

        <nav style={{ flex:1, display:'flex', flexDirection:'column', gap:4 }}>
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink key={to} to={to} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <Icon size={16} /><span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div style={{ borderTop:'1px solid var(--border)', paddingTop:16, display:'flex', alignItems:'center', gap:8 }}>
          <div style={{
            width:34, height:34, borderRadius:'50%',
            background:'var(--glow)',
            border:'1px solid var(--border)',
            display:'flex', alignItems:'center', justifyContent:'center',
            fontWeight:700, fontSize:13, color:'var(--accent)', flexShrink:0
          }}>
            {user?.name?.charAt(0).toUpperCase()}
          </div>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:13, fontWeight:600, color:'var(--text)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
              {user?.name}
            </div>
            <div style={{ fontSize:11, color:'var(--muted)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
              {user?.email}
            </div>
          </div>
          <button onClick={handleLogout} className="btn btn-ghost" title="Logout">
            <LogOut size={15} />
          </button>
        </div>
      </aside>

      <main style={{ flex:1, overflowX:'hidden', minWidth:0, background:'var(--bg)' }}>
        <Outlet />
      </main>
    </div>
  );
}